import { breakpointMediaQueries, getProp } from "@insite/mobius/utilities";
import translate from "@insite/client-framework/Translate";
import Typography from "@insite/mobius/Typography";
import { ThemeProps, css, withTheme } from "styled-components";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import React, { ChangeEvent, useEffect, useState } from "react";
import GridContainer, { GridOffset } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps, GridItemStyle } from "@insite/mobius/GridItem";
import Radio, { RadioStyle } from "@insite/mobius/Radio";
import RadioGroup, { RadioGroupProps, RadioGroupStyle } from "@insite/mobius/RadioGroup";
import TextField from "@insite/mobius/TextField";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import Button, { ButtonPresentationProps } from "@insite/mobius/Button";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { connect } from "react-redux";
import { getCurrentCountries } from "@NA/Store/Data/Countries/CountriesSelector";
import TypographyStyle from "@insite/mobius/Typography/TypographyStyle";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { FormFieldStyle } from "@insite/mobius/FormField";
import getColor from "@insite/mobius/utilities/getColor";
import CustomModelRecap from "./ADICustomModalRecap";
import styled from "styled-components";
import ADIColors from "@NA/Utils/ADIColors";
import { addBankAccount, validateAddress } from "@NA/Services/ADIInvoiceRecapBankAccountService";
import Icon from "@insite/mobius/Icon";
import ValidationSuccessIcon from "@NA/Icons/ValidationSuccessIcon";
import LoadingSpinner from "@insite/mobius/LoadingSpinner";
import Select from "@insite/mobius/Select";
import ADINewAccountAddressSuggestionModalRecap from "./ADINewAccountAddressSuggestionModalRecap";

export interface ADINewCreditCardModalRecapStyles {
    editInputWapper?: InjectableCss;
    newListContainer?: InjectableCss;
    cardTypeRadioGroup?: RadioGroupProps;
    errorGrid?: InjectableCss;
    expError?: InjectableCss;
    headingError?: InjectableCss;
    continueButton?: ButtonPresentationProps;
    labelText?: InjectableCss;
    buttonGridItem?: GridItemProps;
    primaryButton?: ButtonPresentationProps;
    secondaryButton?: ButtonPresentationProps;
    container?: InjectableCss;
    tabs?: InjectableCss;
    successMessage?: InjectableCss;
    okButton?: InjectableCss;
    centeringWrapper?: InjectableCss;
    spinner?: InjectableCss;
    inputText?: InjectableCss;
    primaryGreyButton?: InjectableCss;
    validationErrorMessage?: InjectableCss;
}

export const adiNewCreditCardModalRecapStyles: ADINewCreditCardModalRecapStyles = {
    container: {
        css: css`
            display: flex;
            padding: 2px;
            border-radius: 6px;
            border: solid 1px ${ADIColors.gray2};
            background: ${ADIColors.white};
            max-width: 400px;
            width: 100% !important;
        `,
    },
    tabs: {
        css: css`
            padding: 7px 30px;
            border-radius: 6px;
            border: 0;
            background-color: ${ADIColors.white};
            text-align: center;
            font-size: ${getProp("theme.typography.headerTertiary.size")};
            line-height: 22px;
            font-weight: normal;
            display: flex;
            justify-content: center;
            align-items: center;
            cursor: pointer;
            transition: all 0.1s ease;
            position: relative;
            overflow: visible;
            flex: 1;

            &:nth-of-type(2) {
                margin-left: 10px;
            }

            &:last-child::after {
                display: none;
            }

            &.active {
                background-color: ${ADIColors.darkBlue1};
                color: ${ADIColors.white};
                font-weight: 600;
            }
        `,
    },
    newListContainer: {
        css: css`
        max-width: 50rem !important;
        margin-top: 10px;
            > ${GridOffset} {
                > ${GridItemStyle} {
                    display: flex;
                    flex-direction: column;
                    padding-top: 0px;
                    padding-bottom: 0px;
                    margin-bottom: 1rem;
                    > ${TypographyStyle} {
                        margin-bottom: 2px;
                    }
                }
            }
        `,
    },
    labelText: {
        css: css`
            min-height: 19px;
            font-weight: 800;
            line-height: normal;
            color: ${getColor("text.main")};
        `,
    },
    cardTypeRadioGroup: {
        css: css`
            flex-direction: row;
            justify-content: center;
            margin-bottom: 0;
            legend {
                font-size: ${getProp("theme.typography.headerSecondary.size")};
                font-weight: bold;
            }
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        flex-direction: column;
                        justify-content: start;
                        gap: 8px;
                    `,
                    css`
                        flex-direction: column;
                        justify-content: start;
                        gap: 8px;
                    `,
                    css`
                        flex-direction: row;
                        justify-content: center;
                    `,
                    css`
                        flex-direction: row;
                        justify-content: center;
                    `,
                    css`
                        flex-direction: row;
                        justify-content: center;
                    `,
                ])}
            > ${RadioStyle} {
                margin-top: 0px !important;
                label {
                    font-size: ${getProp("theme.typography.h6.size")};
                    font-weight: normal;
                }
            }
        `,
    },
    editInputWapper: {
        css: css`
            display: flex;
            margin-bottom: 3px;
            width: 100%;
            gap: 15px;
        `,
    },
    errorGrid: {
        css: css`
            ${FormFieldStyle} {
                ${TypographyStyle} {
                    color: ${getColor("danger")};
                }
            }
            ${RadioGroupStyle} {
                legend {
                    color: ${getColor("danger")} !important;
                }
            }
        `,
    },
    expError: {
        css: css`
            color: ${getColor("danger")} !important;
        `,
    },
    headingError: {
        css: css`
            color: ${getColor("danger")};
        `,
    },
    continueButton: {
        css: css`
            border-radius: 4px;
            width: 160px;
        `,
    },
    buttonGridItem: {
        css: css`
            flex-direction: row !important;
            justify-content: end;
            gap: 10px;
            margin-bottom: 15px !important;
            width: 100% !important;
            padding: 0px;
        `,
    },
    primaryButton: {
        css: css`
            border-radius: 4px;
            flex: 1;
        `,
    },
    secondaryButton: {
        css: css`
            border-radius: 4px;
            flex: 1;
        `,
    },
    primaryGreyButton: {
        css: css`
            border-radius: 4px;
            flex: 1;
            opacity: 0.5;
            cursor: default;
            outline: none;
            border-color: ${ADIColors.primaryDisabledColor} !important;
            background-color: ${ADIColors.primaryDisabledColor};
            &:hover {
                background-color: ${ADIColors.primaryDisabledColor} !important; 
            }
            &:focus {
                outline-color: unset;
            }
        `,
    },
    successMessage: {
        css: css`
        display: inline-flex;
        width: 100%;
        height: 54px;
        margin: 10px 12px 16px 0px;
        font-size: 14px;
        font-weight: 800;
        font-stretch: normal;
        font-style: normal;
        line-height: 1.29;
        letter-spacing: normal;
        color: ${ADIColors.black};
        `
    },
    okButton: {
        css: css`
            border-radius: 4px;
            width:  100%;
            margin-bottom: 15px;
        `
    },
    centeringWrapper: {
        css: css`
            width: 100%;
            padding: 30px;
            display: flex;
            align-items: center;
        `,
    },
    spinner: {
        css: css`
            margin: auto;
        `,
    },
    inputText: {
        css: css`
            padding: 10px !important;
        `
    },
    validationErrorMessage: {
        css: css`
            font-size: 14px;
            font-weight: bold;
            font-stretch: normal;
            font-style: normal;
            letter-spacing: normal;
            color: ${ADIColors.black} !important;
            margin-bottom: 16px;
            display: flex;
            align-items: center;
            gap: 8px;
        `
    }
};

const mapStateToProps = (state: ApplicationState) => {
    return {
        countries: getCurrentCountries(state),
    };
};

export interface address {
    province: ((string | number | string[]) & (string | number)) | undefined;
    "uri": string,
    "isNew": boolean,
    "oneTimeAddress": boolean,
    "label": string,
    "validation": null,
    "isDefault": boolean,
    "id": string,
    "customerNumber": string,
    "customerSequence": string,
    "customerName": string,
    "firstName": string,
    "lastName": string,
    "contactFullName": string,
    "companyName": string,
    "attention": string,
    "address1": string,
    "address2": string,
    "address3": string,
    "address4": string,
    "city": string,
    "postalCode": string,
    "state": {
        "uri": string,
        "id": string,
        "name": string,
        "abbreviation": string,
        "properties": object
    },
    "country": {
        "uri": string,
        "id": string,
        "name": string,
        "abbreviation": string,
        "states": object,
        "properties": object
    },
    "phone": string,
    "fullAddress": string,
    "email": string,
    "fax": string,
    "isVmiLocation": boolean,
    "properties": {
        "cclevel": string,
        "consolidatedinvflag": string,
        "freeshipthresholdamt": string,
        "isdropship": string,
        "legacyadmindc": string,
        "legacycompanycode": string,
        "legacycustomernumber": string,
        "legacycustomersuffix": string,
        "newquoteaddress": string,
        "prefshiptoloc": string,
        "isDropShip": string
    }
}

interface customerData {
    email: string,
    customerName: string,
    accountDescription: string,
    accountType: string,
    bankAccountNumber: string,
    routineNumber: string,
    termsAgreed: string
}

interface OwnProps {
    isFormError: boolean;
    isApiError: boolean;
    openModal: boolean;
    closeModal: Function;
    initiatedByUserName: string;
    closeAddressModal: Function;
    address: address;
    customerData: customerData | undefined;
}

interface Errors {
    companyName: string,
    city: string,
    address1: string,
    province: string,
    postalCode: string,
}

type Props = OwnProps & ReturnType<typeof mapStateToProps> & ThemeProps<BaseTheme>;

const styles = adiNewCreditCardModalRecapStyles;

const SuccessMessage = styled.div`
    padding: 2px;
    display: flex;
    margin: 5px 0 7px;
    gap: 15px;
    margin-bottom: 15px;
    margin-top: 15px;
    align-items: center;
`;

const ADINewAccountAddressModalRecap = ({
    closeModal,
    openModal,
    isFormError,
    isApiError,
    initiatedByUserName,
    closeAddressModal,
    address,
    countries,
    customerData,
}: Props) => {
    const [isLoading, setIsLoading] = useState(false);
    const [isApiErrorMessage, setIsApiErrorMessage] = useState("");
    const [isSuccess, setIsSuccess] = useState(false);
    const [addressApiResult, setAddressApiResult] = useState<any>([]);
    const [isAddressSuggestionModalOpen, setIsAddressSuggestionModalOpen] = useState(false);
const [suggestionWraningMessage, setSuggestionWraningMessage] = useState<string>("")

    const [errors, setErrors] = useState<Errors>({
        companyName: '',
        city: '',
        address1: '',
        province: '',
        postalCode: '',
    });
    const [addressFormData, setAddressFormData] = useState(address);
    const [addressValidationErrorMessage, setAddressValidationErrorMessage] = useState<string[]>([]);


    useEffect(() => {
        setAddressFormData({ ...address, province: "" });
    }, [openModal]);


    const addAccount = async () => {
        setIsLoading(true);
        try {
            const payload = {
                ...customerData,
                address1: address?.address1,
                address2: address?.address2,
                city: address?.city,
                companyName: address?.companyName,
                stateProv: address?.state?.abbreviation,
                states: address?.state,
                zipCode: address?.postalCode,
                termsAgreementPDFPath: "https://cdn.en.adiglobaldistribution.ca/userfile-na/CA/userfiles/Terms&Agreement/CANBankTermsAgreement_V1.20210811.pdf"
            }
            const result = await addBankAccount(payload);
            if (result?.successful) {
                setIsSuccess(true);
                setIsAddressSuggestionModalOpen(false);
            } else {
                setIsApiErrorMessage(result?.result?.returnMessage);
            }
        } catch (error) {
            throw error;
        }
        setIsLoading(false);
    }
    const compareAddresses = (originalAddress: any, propsedAddress: any) => {
        // Check if all relevant fields are the same
        return (
            originalAddress.address1 === propsedAddress.address1 &&
            originalAddress.address2 === propsedAddress.address2 &&
            originalAddress.address3 === propsedAddress.address3 &&
            originalAddress.city.toUpperCase() === propsedAddress.city.toUpperCase() &&
            originalAddress.state.abbreviation.toUpperCase() === propsedAddress.stateProv.toUpperCase() &&
            originalAddress.postalCode === propsedAddress.postalCode &&
            originalAddress.country.abbreviation.toUpperCase() === propsedAddress.country.toUpperCase()
        );
    }

    const handleValidateAddress = async () => {
        setIsLoading(true);
        const payload = {
            address1: addressFormData.address1,
            address2: addressFormData.address2,
            city: addressFormData.city,
            companyName: addressFormData.companyName,
            country: countries && countries[0],
            postalCode: addressFormData.postalCode,
            state: { abbreviation: addressFormData.state.abbreviation }
        }
        const result = await validateAddress(payload);
        const commonValidationErrors = [
            translate("Street Not Validated"),
            translate("City/State Not Validated"),
            translate("Postal Code Not Validated")
        ]
        if (result.successful) {
            setIsLoading(false);
            if (result.result?.proposedAddress?.validationScore >= 80 && result.result?.proposedAddress?.validated === "Y") {
                if (result.result.validationMessage === "") {
                    const comparisionResult = compareAddresses(result.result?.originalAddress, result.result?.proposedAddress);
                    if (comparisionResult) {
                        addAccount();
                    } else {
                        closeModal();
                        setAddressApiResult(result);
                        setIsAddressSuggestionModalOpen(true);
                        setSuggestionWraningMessage("")
                        setErrors({
                            companyName: '',
                            city: '',
                            address1: '',
                            province: '',
                            postalCode: '',
                        });
                    }
                }
            } else if (result.result?.proposedAddress?.validationScore < 80 && result.result?.proposedAddress?.validated === "Y") {
                if (result.result.validationMessage !== "") {
                    const validationError = (result.result.validationMessage?.split(";")).filter((ele: string) => ele !== " ");
                    const isOtherError = validationError.every((element: string) => commonValidationErrors.includes(element.trim()));
                    if (!isOtherError) {
                        setAddressValidationErrorMessage([translate("Please Enter valid Address")]);
                    } else {
                        const updatedErrors:any = { ...errors };
                        validationError.forEach((message: string) => {
                            let fieldName:string = "";
                            let errorMessage:string = "";

                            if (message.toLowerCase().includes("street")) {
                                fieldName = "address1";
                                errorMessage = " ";
                            } else if (message.toLowerCase().includes("city/state")) {
                                fieldName = "city";
                                errorMessage = " ";
                            } else if (message.toLowerCase().includes("postal")) {
                                fieldName = "postalCode";
                                errorMessage = " ";
                            }
                            if (fieldName && errorMessage) {
                                updatedErrors[fieldName] = errorMessage;
                            }
                        });
                        setErrors(updatedErrors);
                        setAddressValidationErrorMessage(validationError);
                    }
                } else {
                    closeModal();
                    setAddressApiResult(result);
                    setIsAddressSuggestionModalOpen(true);
                    setSuggestionWraningMessage(translate('Unable to Validate address. Please choose whether you want to use the address you provided or the one we suggest'))
                    setErrors({
                        companyName: '',
                        city: '',
                        address1: '',
                        province: '',
                        postalCode: '',
                    });
                }
            }
        }
    }
    const handleFormChange = (e: any) => {
        const { name, value } = e.target;
        setAddressFormData({ ...addressFormData, [name]: value });

        // Error validation logic
        let error = '';
        if (name === 'companyName' && value.trim() === '') {
            error = 'Company name is required';
        } else if (name === 'city' && value.trim() === '') {
            error = 'City is required';
        } else if (name === 'address1' && value.trim() === '') {
            error = 'Address Line 1 is required';
        } else if (name === 'postalCode' && value.trim() === '') {
            error = 'Postal code is required';
        }
        // Update errors state
        setErrors({ ...errors, [name]: error });
    }
    const handleSuggestionSelection = (selectedAddress: string) => {
        addAccount()
    }
    return (

        <>
            <CustomModelRecap
                headline={translate("For Customers Using Canadian Banking Institutions")}
                subheading={isSuccess ? "" : translate("* Required Fields")}
                isOpen={openModal}
                errorStyle={isFormError ? true : false}
                handleClose={closeModal}
            >
                <>
                    {isApiErrorMessage && (
                        <Typography color="danger" size={14}>
                            {isApiErrorMessage}
                        </Typography>
                    )}
                    {addressValidationErrorMessage && addressValidationErrorMessage.map(error => {
                        return (
                            <Typography color="danger" size={14}>
                                {translate(`* ${error}`)}<br />
                            </Typography>
                        )
                    })}

                    {!isSuccess && <GridContainer {...styles.newListContainer}>
                        <GridItem width={12}>
                            {isFormError && (
                                <Typography color="danger" size={14}>
                                    {translate("* Required Fields")}
                                </Typography>
                            )}

                        </GridItem>
                        <GridItem width={12}>
                            <Typography size={18}>
                                {translate("Beneficiary Bank Account")}
                            </Typography>
                        </GridItem>
                        <GridItem width={6} >
                            <Typography variant="headerSecondary" {...styles.labelText}>
                                {translate("Company *")}
                            </Typography>
                            <TextField
                                {...styles.inputText}
                                value={addressFormData?.companyName}
                                name="companyName"
                                onChange={handleFormChange}
                                error={errors.companyName !== '' ? errors.companyName : ""}
                            />
                        </GridItem>
                        <GridItem width={6} >
                            <Typography variant="headerSecondary" {...styles.labelText}>
                                {translate("City *")}
                            </Typography>
                            <TextField
                                {...styles.inputText}
                                value={addressFormData?.city}
                                name="city"
                                onChange={handleFormChange}
                                error={errors.city !== '' ? errors.city : ""}
                            />
                        </GridItem>
                        <GridItem width={6} >
                            <Typography variant="headerSecondary" {...styles.labelText}>
                                {translate("Address Line1 *")}
                            </Typography>
                            <TextField
                                {...styles.inputText}
                                value={addressFormData?.address1}
                                name="address1"
                                onChange={handleFormChange}
                                error={errors.address1 !== '' ? errors.address1 : ""}
                            />
                        </GridItem>
                        <GridItem width={6} >
                            <Typography variant="headerSecondary" {...styles.labelText}>
                                {translate("Province *")}
                            </Typography>
                            <Select border="rounded" value={addressFormData?.province} name="province"
                                onChange={handleFormChange}>
                                {countries && countries.length > 0 && countries[0]?.states?.map((state: any) => {
                                    return <option value={state?.name}> {state?.name} </option>
                                })}
                            </Select>
                        </GridItem>
                        <GridItem width={6} >
                            <Typography variant="headerSecondary" {...styles.labelText}>
                                {translate("Address Line2")}
                            </Typography>
                            <TextField
                                {...styles.inputText}
                                value={addressFormData?.address2}
                                name="address2"
                                onChange={handleFormChange}
                            />
                        </GridItem>
                        <GridItem width={6} >
                            <Typography variant="headerSecondary" {...styles.labelText}>
                                {translate("Postal Code *")}
                            </Typography>
                            <TextField
                                {...styles.inputText}
                                value={addressFormData?.postalCode}
                                name="postalCode"
                                onChange={handleFormChange}
                                error={errors.postalCode !== '' ? errors.postalCode : ""}
                            />
                        </GridItem>

                        <GridItem width={12} >
                            <Typography variant="headerSecondary" {...styles.labelText}>
                                {translate("Business Pre-Authorized Debit (“Pad”) Terms and Conditions")}
                            </Typography>
                            <ol type="1">
                                <li>
                                    <strong>Authorization:</strong> This business pre-authorized debit agreement (<strong>“PAD Agreement”</strong>) is between you and Ademco III, Ltd., doing business as ADI Global Distribution (also referred to as <strong>“ADI”, “we” or “us”</strong>). You authorize ADI to make pre-authorized debits from the bank account that you identify from time to time (the <strong>“Account”</strong>) with the financial institution that you designate to us on this ADI Website (the <strong>“Website”</strong>) for the purpose of making the payment amount you specify from time to time (the <strong>“PAD Amount”</strong>). You agree to notify us immediately if your Account information changes and this authorization will continue in respect of any new Account that you identify to us
                                </li>
                                <li>
                                    <strong>PAD Category:</strong> This PAD Agreement is a “Business PAD”, as such term is defined in the Canadian Payment Association Rule H1 (<strong>“Rule H1”</strong>).
                                </li>
                                <li>
                                    <strong>Amount:</strong> The PAD Amount will be variable based on the amount you specify from time to time on the Website. If your financial institution returns a PAD because of insufficient funds, you agree that we may re-present, on a one-time basis only, the PAD within thirty (30) calendar days of the returned PAD date. The amount re-presented will be the amount of the original PAD.
                                </li>
                                <li>
                                    <strong>Frequency:</strong> PADs will be sporadic based on the PAD Amount. This PAD Agreement authorizes “Sporadic PADs” within the meaning of Rule H1. Accordingly, you agree by way of this PAD Agreement to “Authorize” (within the meaning of Rule H1) us for each and every Sporadic PAD under this PAD Agreement prior to the PAD Amount being exchanged and cleared by submitting your payment on the Website or via telephonic instruction/confirmation. Your use of the Website to process each PAD Amount (by clicking the <strong>Submit</strong> will constitute valid and due Authorization for each Sporadic PAD and will constitute delivery of your authorization to your financial institution to debit your Account for the PAD Amount).
                                </li>
                                <li>
                                    <strong>
                                        <u>
                                            Waiver of Pre-Notification and Confirmation: Your use of the Website to process a PAD Amount determines when the PAD is processed and therefore you agree to waive any pre-notification of the PAD.
                                        </u>
                                    </strong>
                                </li>
                                <li>
                                    <strong>Your Right to Cancel the PAD:</strong> Your authorization under this PAD Agreement will remain in effect until we have received notification from you of your cancellation of this PAD Agreement. You may cancel your PAD Agreement at any time by providing at least thirty (30) written calendar days’ notice. In the event you remove your bank account, the PAD agreement will automatically be terminated.

                                    To obtain a sample cancellation form or for more information on your right to cancel your PAD Agreement, you may contact your financial institution or visit <a href="www.payments.ca" target="_blank">www.payments.ca</a>.

                                    Cancelling the PAD Agreement does not terminate any of your duties or obligations that exist between you and us, including your obligation to pay the amounts outstanding from time to time on your account with us.
                                </li>
                                <li>
                                    <strong>Recourse / Reimbursement:</strong> You have certain recourse rights if any debit does not comply with this PAD Agreement. For example, you have the right to receive reimbursement for any debit that is not authorized or is not consistent with this PAD Agreement. To obtain more information on your recourse rights, contact your financial institution or visit <a href="www.payments.ca" target="_blank">www.payments.ca</a>.
                                </li>
                                <li>
                                    <strong>Validation by Financial Institution:</strong> You acknowledge your financial institution is not required to verify that the transaction is debited in accordance with the terms of this PAD Agreement.
                                </li>
                                <li>
                                    <strong>Changes to Your Information:</strong> It is your responsibility to ensure the information in the Website is accurate. You agree to tell us right away of any change in your name, address or telephone numbers, and any change in your financial institution or Account information. A change in your financial institution or Account information will require you to sign a new PAD Agreement.
                                </li>
                                <li>
                                    <strong>Delivery Authorization:</strong> You acknowledge that delivery of this PAD Agreement to you constitutes delivery of it to us and by you to your financial institution.
                                </li>
                                <li>
                                    <strong>Consent:</strong> I represent that all persons whose signatures are required to sign on the Account have read this PAD Agreement. In addition, I represent, where applicable, that I have the authority to electronically agree to commit to this PAD Agreement and to add or change the Account on the Website and the password, security code or other signature equivalent and that such authorization(s) confirms with the requirements of Rule H1.
                                </li>
                                <li>
                                    <strong>Assignment and Inurement:</strong> ADI may assign at any time all or a portion of its rights and obligations under this PAD Agreement. You may not assign this PAD Agreement or any of your rights or obligations under this PAD Agreement. All of ADI's rights under this PAD Agreement shall inure to the benefit of its successors and assigns.
                                </li>
                                <li>
                                    <strong>Contacting us:</strong> For any questions about this PAD Agreement, you may contact us at the following address and phone number:

                                    ADI Global Distribution
                                    Attn: Kerry Schait
                                    263 Old Country Road
                                    Melville, NY 11747
                                    <strong>Email address:</strong> <a>arcollections@adiglobal.com</a>
                                </li>
                                <li>
                                    <strong>Governing Law:</strong> This PAD Agreement will be governed by and interpreted in accordance with the applicable laws of the Province of Ontario and the federal laws applicable therein. You agree to submit to and be bound by these laws and the courts of the Province of Ontario in the event of any disputes arising in connection with this PAD Agreement.
                                </li>
                                <li>
                                    You acknowledge and agree that all sales of Product are governed by ADI's standard terms and conditions of sale, located at <a href="www.adiglobal.com" target="_blank">www.adiglobal.com</a>.
                                </li>
                                <li>
                                    <strong>Disclosure:</strong> You consent to the disclosure of any information that may be contained in this PAD Agreement or any PAD to the financial institution that holds the account of ADI to be credited with the PAD to the extent that such disclosure of information is directly related to and necessary for the proper application of Rule H1.
                                </li>
                                <li>
                                    It is the express wish of the parties that this PAD Agreement and any related documents be drawn up and executed in English. Les parties souhaitent expressément que cet accord PAD et tous les documents connexes soient rédigés et exécutés en anglais.
                                </li>
                                <li>
                                    By clicking "agree" you agree to the terms and conditions contained herein.
                                </li>
                            </ol>
                        </GridItem>
                        <GridItem
                            width={12}
                            css={css`
                            align-items: center;
                        `}
                        >
                            {!isLoading && (
                                <GridItem width={6} {...styles.buttonGridItem}>
                                    <Button onClick={() => closeAddressModal()} variant="secondary" {...styles.secondaryButton}>
                                        {translate("Disagree")}
                                    </Button>
                                    {!errors ? <Button variant="primary" {...styles.primaryGreyButton}>
                                        {translate("Agree")}
                                    </Button> : <Button onClick={() => handleValidateAddress()} variant="primary" {...styles.primaryButton}>
                                        {translate("Agree")}
                                    </Button>}
                                </GridItem>
                            )}
                            {isLoading &&
                                <StyledWrapper {...styles.centeringWrapper}>
                                    <LoadingSpinner {...styles.spinner} />
                                </StyledWrapper>
                            }
                        </GridItem>
                    </GridContainer>
                    }
                </>
            </CustomModelRecap>

            <ADINewAccountAddressSuggestionModalRecap openModal={isAddressSuggestionModalOpen} closeModal={closeModal} address={addressApiResult.result} closeAddressModal={closeAddressModal} handleSuggestionSelection={handleSuggestionSelection} title="New Address" warningMessage={suggestionWraningMessage} />
        </>
    );
};

export default connect(mapStateToProps)(withTheme(ADINewAccountAddressModalRecap));
